import React, { createContext, useContext, useState } from "react";
import { getMrqData, getMrqs } from "../../api";
import { getHashdata } from "../../../../../../../../components/Tabs/Utils/hashFunctions";
import { ifMrqUrl } from "./ifMrqUrl";
import { useMcsContext } from "../../../MCS.context";
import { secondAxios } from "../../../../../../../../api/axios";

const MrqContext = createContext();
export const useMrqContext = () => useContext(MrqContext);

function MrqContextProvider({ children }) {
  const { plant, setPlant, setSelectedMrqData, mrqList, setMrqList } =
    useMcsContext();

  const mrqData = plant?.selectedMrq;

  const [mrqSelection, setMrqSelection] = React.useState({
    selectedMrq: "",
    revisions: [],
    selectedRevision: "",
  });

  const [openAddPoModal, setOpenAddPoModal] = React.useState(false);

  const [isEditMode, setIsEditMode] = useState(false);
  const [updatedMrq, setUpdatedMrq] = useState(plant?.selectedMrq);
  console.log("updated mrq:?", updatedMrq);
  const mrqId = getHashdata(window.location.hash, "mrq-id");

  React.useEffect(() => {
    const showMrqByUrl = async () => {
      mrqId &&
        (await ifMrqUrl({
          mrqId,
          setSelectedMrqData,
          setMrqSelection,
        }));
    };

    showMrqByUrl();
  }, [mrqId]);

  React.useEffect(() => {
    const fetchMrqList = async () => {
      await getMrqs({ plantId: plant.id }).then((res) => setMrqList(res));
    };

    fetchMrqList();
  }, []);

  // React.useEffect(() => {
  //   const revisions = mrqData?.revs ? mrqData.revs : [];

  //   setMrqSelection({
  //     selectedMrq: mrqData?.id,
  //     revisions,
  //     selectedRevision: mrqData?.id,
  //   });
  // }, [mrqData?.id]);

  React.useEffect(() => {
    // console.log({ mrqSelection });
    const fetchMrqThenBidData = async () => {
      if (mrqSelection.selectedMrq) {
        const mrq = await getMrqData(
          mrqSelection.selectedRevision || mrqSelection.selectedMrq,
        );

        setSelectedMrqData(mrq);
      }
    };

    fetchMrqThenBidData();
  }, [mrqSelection.selectedRevision, mrqSelection.selectedMrq]);

  const onEditMrq = () => {
    // console.log("onEditMrq");
    setUpdatedMrq(plant?.selectedMrq);
    setIsEditMode(true);
  };

  const onChangeDetails = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);
    setUpdatedMrq({ ...updatedMrq, [name]: value });
  };

  const onChangeCell = (e, rowId) => {
    const { name, value } = e.target;
    // console.log(name, value);

    const newMaterials = updatedMrq?.mrqMaterials?.map((m) => {
      return m.id === rowId
        ? {
            ...m,
            [name]: value,
          }
        : m;
    });

    setUpdatedMrq({ ...updatedMrq, mrqMaterials: newMaterials });
  };
  const onSubmitEditMrq = async () => {
    // console.log("updatedMrq Submit", updatedMrq);
    const res = await secondAxios.put("mrq/" + mrqData?.id, updatedMrq);
    // console.log("updatedMrq res", res);
    if (res?.data) {
      setPlant({ ...plant, selectedMrq: res.data });
    }
    setIsEditMode(false);
  };

  return (
    <MrqContext.Provider
      value={{
        plant,

        mrqList,
        setMrqList,
        mrqSelection,
        setMrqSelection,
        mrqData: isEditMode ? updatedMrq : mrqData,

        openAddPoModal,
        setOpenAddPoModal,

        onEditMrq,
        isEditMode,
        setIsEditMode,

        updatedMrq,
        setUpdatedMrq,
        onChangeDetails,
        onChangeCell,
        onSubmitEditMrq,
      }}
    >
      {children}
    </MrqContext.Provider>
  );
}
export { MrqContextProvider, MrqContext };
